import { FC, useState } from 'react';
import { Button } from 'antd';
import styled from 'styled-components';

import { debugTools } from '@/shared/utils/debug/debugTools';

export const TabLogs: FC = () => {
  const [ts, setTs] = useState(0);

  return (
    <Container>
      <div>
        <Button onClick={() => setTs(Date.now())} key={ts}>
          refresh
        </Button>
      </div>
      <LogContainer>
        {debugTools.logs.map(([type, ...params], index) => (
          <LogItem key={index}>
            {type} {params.join(' ')}
          </LogItem>
        ))}
      </LogContainer>
    </Container>
  );
};

const LogContainer = styled.div`
  dsplay: flex;
  flex-direction: column;
  align-items: center;
`;

const LogItem = styled.div`
  height: 20px;
  white-space: nowrap;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
